import styled from 'styled-components';
import Image from '@stencil/image';

export const GoTribeReviewFooterWrapper = styled.div(
  props => `
    background: #EFF3F8;
    border-radius: 1.2rem;
    display: flex;
    width: 100%;
    overflow:hidden;
    position: relative;
    padding: ${props.isMweb ? '1.2rem' : '1.8rem 1.2rem'};
    margin: ${props.isMweb ? '1.2rem 0 1rem' : '1.2rem 0 2rem'};
      `,
);

export const GoTribeReviewFooterHeaderWrapper = styled.div(
  props => `
      display: flex;
        `,
);

export const GoTribeTextWrapper = styled.div(
  props => `
    width: 71px;
    height: 71px;
    background: #FFF3DB;
    position: absolute;
    border-radius: 50%;
    top: -16px;
    left: -6px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 4px;
      `,
);

export const GoTribeSuperStarImgWrapper = styled.div(
  props => `
  width: 54px;
  height: 54px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items:center;
  position: relative;
  margin-right: 8px;
  flex-shrink: 0;
      `,
);

export const GoTribeSuperStar = styled(Image)(
  props => `
  width: ${props.goTribeStarIcon ? '57px' : '63px'};
  height: ${props.goTribeStarIcon ? '53px' : '71px'};
  top: ${props.goTribeStarIcon ? '-4px' : 0};
  position: absolute;
      `,
);

export const GoTribeSuperStarImgWrapperGradient = styled.div(
  props => `
  background:${props.iconColor};
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
      `,

  //  To be removed after QA
  // ${background: $}
  //   props.goTribeStarIcon
  //     ? 'linear-gradient(315deg, #FF6E1D 0%, #EA2F2F 100%)'
  //     : 'linear-gradient(315deg, #F8CD46 0%, #F4A900 100%)'
  // };
);

export const GoTribeImg = styled(Image)(
  props => `
  width: 82px;
  height: 82px;
  margin-right: 8px;
  object-fit: contain;
  padding: 1rem;
  `,
);

export const GoTribeReviewFooterBodyWrapper = styled.div(
  props => `
      ${!props.isMweb &&
        `display: flex;
         flex: 1;
      `};
       
        `,
);

export const GoTribeHeaderText = styled.p(
  props => `
    padding-bottom: 0.8rem;
    font-size: ${props.isMweb ? '1.4rem' : '1.6rem'};
    line-height: 1.6rem;
    color: ${props.theme.colors.black};
    font-weight: 700;
      `,
);

export const GoTribeDescText = styled.p(
  props => `
    padding-bottom: 1.2rem;
    font-size: ${props.isMweb ? '1.1rem' : '1.4rem'};
    line-height: ${props.isMweb ? '1.3rem' : '1.8rem'};
    color: ${props.theme.colors.downriver.medium};
    ${!props.isMweb && 'max-width: 30rem'};
      `,
);

export const GoTribeFooterText = styled.p(
  props => `
    font-size: 1rem;
    line-height: 1.4rem;
    color: #F26826;
    display: flex;
    align-items: ${props.isMweb ? 'center' : 'flex-start'};
    font-weight: 700;
     ${!props.isMweb && 'max-width: 133px'};

        > svg {
        animation: rotating 2s linear infinite;
        } 

        @keyframes rotating {
        from{
            transform: rotate(0deg);
        }
        to{
            transform: rotate(360deg);
        }
    
       

      `,
);

export const GoTribeFooterCta = styled.a(
  props => `
    font-size: 1rem;
    line-height: 1.4rem;
    color: ${props.theme.colors.goBrandBlue.base};
    display: flex;
    align-items: center;
    border: 1px solid ${props.theme.colors.goBrandBlue.base};
    border-radius: 0.8rem;
    padding: 0.2rem 0.8rem 0.2rem 0.4rem;
    font-weight: 700;
    width: 8.2rem;
    :after {
      content: "";
      display: inline-block;
      padding: 1px;
      border-left: 1px solid ${props.theme.colors.goBrandBlue.base};
      border-top: 1px solid ${props.theme.colors.goBrandBlue.base};
      width: ${props.isMweb ? '3px' : '5px'};
      height: ${props.isMweb ? '3px' : '5px'};
      margin-left: 3px;
      transform: rotate(135deg);
    }
      `,
);

export const GoTribeShapes = styled.span(
  props => `
  width: ${props.goTribeStarIcon ? '57px' : '63px'};
  height: ${props.goTribeStarIcon ? '53px' : '71px'};
  top: ${props.goTribeStarIcon ? '-4px' : 0};
  position: absolute;
      `,
);

export const LoaderWrapper = styled.div(
  props => `
      margin-left: auto;
}
      `,
);
